import React from 'react'
import { useTranslation } from 'react-i18next'
import {
    Avatar,
    IconButton,
    Tooltip,
} from '@material-ui/core'
import { goToUrl } from '../../utils/UrlManipulation'
import { useProfile } from '../../utils/Hooks'

const ProfileButton = () => {
    const { t } = useTranslation()
    const [user, loading] = useProfile()

    return (
        <Tooltip title={t('tooltips.profile')} aria-label={t('tooltips.profile')} onClick={() => goToUrl("/profile")}>
            <IconButton>
                {loading
                    ? <Avatar />
                    : <Avatar alt={user.name} src={user.picture}>{user.name[0]}</Avatar>
                }
            </IconButton>
        </Tooltip >
    )
}

export default ProfileButton